/*************************************************************************
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { inject } from "mobx-react";
import { getCursorQuad, getCursorPageIndex, getIsCursorVisible } from "dc-preview-utils/src/selectors/cursorSelectors";
import { getTransformedCursorInfo } from "utils/CaretModeUtils";
import { getPageZoomLevel } from "selectors/zoom";
import { CursorWrapper } from "components/cursor/CursorWrapper";
import { isDarkPageThemeEnabled } from "selectors/appSelectors";

const getCursorInfo = (stores, pageIndex) => {
  let cursorQuads = getCursorQuad(stores);
  const cursorInfo = getTransformedCursorInfo(cursorQuads, pageIndex, stores);
  return cursorInfo;
};

const mapStoresToProps = stores => {
  const pageIndex = getCursorPageIndex(stores);
  const cursorInfo = getCursorInfo(stores, pageIndex);
  const zoomLevel = getPageZoomLevel(stores, pageIndex);
  return {
    pageIndex,
    cursorInfo,
    zoomLevel,
    isCursorVisible: getIsCursorVisible(stores),
    isDarkPageThemeEnabled: isDarkPageThemeEnabled(stores)
  };
};

export default inject(mapStoresToProps)(CursorWrapper);
